export default __webpack_public_path__ + "static/media/2- Metropolitan Tikhon 2021.f5f85cc1.jpeg";